module.exports = __webpack_public_path__ + "static/media/Sawsbuck_gaussian2.4a387676.png";